/**
 * ProductTableEmpty - Empty state for products table
 *
 * Shows a professional empty state when no products/services have been added.
 */

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateSubtitle,
} from './ProductTableStyles'

interface ProductTableEmptyProps {
  isDraft?: boolean
}

const ProductTableEmpty: React.FC<ProductTableEmptyProps> = ({ isDraft = true }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon>
        <AddCircleOutlineIcon />
      </EmptyStateIcon>
      <EmptyStateTitle>No services added</EmptyStateTitle>
      <EmptyStateSubtitle>
        {isDraft
          ? 'Click "Add Service" above to add products or services to this agreement.'
          : 'This agreement has no services attached.'}
      </EmptyStateSubtitle>
    </EmptyStateContainer>
  )
}

export default ProductTableEmpty
